import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classNames from 'classnames';
import './Btn.scss';
import { SvgCheck, SvgSpinner } from '../../index';
import { Icon } from '../icon/Icon';
import { SIZE } from '../../constants';
export { SIZE };
export const BtnFactory = forwardRef(
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
({ size = SIZE.MED, ...props }, ref) => {
    const handleClick = (e) => {
        props.onClick?.(e, { data: props.data });
    };
    const isWaiting = props.queryState === 'waiting';
    const isSuccess = props.queryState === 'success';
    let className = size === SIZE.SML ? ' sg-btn-sml' : ' sg-btn-med';
    className += ` sg-btn-${props.severity}`;
    className += props.isInverse
        ? ' sg-btn-inverse'
        : props.isDanger
            ? ' sg-btn-danger'
            : ' sg-btn-accent';
    className += props.isSuppressed ? ' sg-btn-suppressed' : '';
    className += props.isActive ? ' sg-btn-isActive' : '';
    className += props.isHovered ? ' sg-btn-isHovered' : '';
    className += props.isDisabled ? ' sg-btn-isDisabled' : '';
    className += isWaiting ? ' sg-btn-isWaiting' : '';
    className += isSuccess ? ' sg-btn-isSuccess' : '';
    className += props.icon ? ' sg-btn-withIcon' : ' sg-btn-withoutIcon';
    className += props.children ? ' sg-btn-withLabel' : ' sg-btn-withoutLabel';
    className += props.unsafeClassName ? ` ${props.unsafeClassName}` : '';
    const inner = (_jsxs("span", { className: 'sg-btn--inner', children: [_jsx("span", { className: classNames({
                    'sg-btn--queryState': true,
                    'sg-btn--queryState-isActive': isWaiting,
                }), children: _jsx(Icon, { element: _jsx(SvgSpinner, {}), size: size }) }), _jsx("span", { className: classNames({
                    'sg-btn--queryState': true,
                    'sg-btn--queryState-isActive': isSuccess,
                }), children: _jsx(Icon, { element: _jsx(SvgCheck, {}), size: size }) }), _jsxs("span", { className: 'sg-btn--content', children: [props.icon && (_jsx("span", { className: classNames('sg-btn--icon', {
                            'sg-btn--icon-right': props.icon.position === 'right',
                        }), children: _jsx(Icon, { element: props.icon.element, badge: props.icon.badge, size: size }) })), props.children && _jsx("span", { className: 'sg-btn--label', children: props.children })] })] }));
    if (props.as === 'button') {
        return (_jsx("button", { ref: ref, className: 'sg-btn' + className, type: props.type ? props.type : 'button', title: props.tooltip, formNoValidate: props.type === 'submit' ? true : undefined, disabled: props.isDisabled || props.queryState !== undefined, tabIndex: props.tabIndex, onClick: handleClick, "data-test-id": props.testId, children: inner }));
    }
    return (_jsx("a", { ref: ref, className: 'sg-btn' + className, title: props.tooltip, href: !props.isDisabled ? props.href : undefined, target: props.target, rel: 'noopener', download: props.download, tabIndex: props.tabIndex, onClick: handleClick, "data-test-id": props.testId, children: inner }));
});
//# sourceMappingURL=BtnFactory.js.map